import { PageLayout } from '@/shared/layout/PageLayout';
import { Button } from '@/components/ui';
import { AuthButton } from '@/core/permissions/AuthButton';
import { ArrowRight } from 'lucide-react';
import { UserNewStepper } from './components/UserNewStepper';
import { BasicInfoStep } from './components/BasicInfoStep';
import { WorkInfoStep } from './components/WorkInfoStep';
import { EmergencyStep } from './components/EmergencyStep';
import { useUserNew } from './hooks/useUserNew';

const TOTAL_STEPS = 3;

export function UsersNewPage() {
  const {
    currentStep,
    formData,
    isSaving,
    companyId,
    updateField,
    generateRandomPassword,
    handleNext,
    handlePrev,
    handleSave,
    setCurrentStep
  } = useUserNew();

  return (
    <PageLayout
      title="Thêm nhân sự"
      description="Tạo mới thông tin nhân sự trong hệ thống"
    >
      <div className="space-y-6">
        <UserNewStepper
          currentStep={currentStep}
          onStepChange={setCurrentStep}
        />

        <div className="mb-24">
          {/* Bước 1: Thông tin cơ bản */}
          {currentStep === 1 && (
            <BasicInfoStep
              formData={formData}
              updateField={updateField}
              generatePassword={generateRandomPassword}
            />
          )}

          {/* Bước 2: Công việc & Học vấn */}
          {currentStep === 2 && (
            <WorkInfoStep
              formData={formData}
              updateField={updateField}
              companyId={companyId}
            />
          )}

          {/* Bước 3: Liên hệ khẩn cấp & Xác nhận */}
          {currentStep === 3 && (
            <EmergencyStep
              formData={formData}
              updateField={updateField}
            />
          )}
        </div>

        {/* Sticky Footer */}
        <div className="fixed bottom-0 left-0 right-0 lg:left-64 bg-white/80 backdrop-blur-md border-t border-slate-100 px-8 py-4 z-20">
          <div className="max-w-[1600px] mx-auto flex items-center justify-between">
            {/* Nút quay lại */}
            <Button
              variant="outline"
              className="text-slate-500 border-slate-100 sm:text-sm text-xs h-10 rounded-md"
              onClick={handlePrev}
              disabled={currentStep === 1}
            >
              Quay lại
            </Button>

            <div className="flex items-center gap-3">
              {/* Chỉ số bước */}
              <span className="sm:text-sm text-xs text-slate-400">
                Bước {currentStep}/{TOTAL_STEPS}
              </span>

              <Button
                variant="ghost"
                className="text-slate-400 sm:text-sm text-xs"
                onClick={() => window.history.back()}
              >
                Hủy bỏ
              </Button>

              {currentStep < TOTAL_STEPS ? (
                <Button
                  className="bg-emerald-700 hover:bg-emerald-800 text-white flex items-center gap-2 pr-4 sm:text-sm text-xs h-10 rounded-md"
                  onClick={handleNext}
                >
                  <span>Tiếp tục</span>
                  <ArrowRight className="w-4 h-4" />
                </Button>
              ) : (
                <AuthButton
                  module="users"
                  action="create"
                  variant="primary"
                  className="bg-emerald-700 hover:bg-emerald-800 text-white sm:text-sm text-xs h-10 rounded-md"
                  onClick={handleSave}
                  isLoading={isSaving}
                >
                  Hoàn tất
                </AuthButton>
              )}
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
